import { Colors } from '@sigma-frontend-libs/commons'

export const permissionAccepts = {
  false: false,
  me: 'me',
  reseller: 'reseller',
  manager: 'manager',
  true: true,
  default: 'default',
  read: 'read',
  write: 'write'
}

export const permissionColors = {
  [permissionAccepts.false]: Colors.error,
  [permissionAccepts.me]: Colors.warning,
  [permissionAccepts.reseller]: Colors.primary,
  [permissionAccepts.manager]: Colors.epic,
  [permissionAccepts.true]: Colors.success,
  [permissionAccepts.default]: Colors.grey,
  [permissionAccepts.read]: Colors.info,
  [permissionAccepts.write]: Colors.success
}
